import { render, staticRenderFns } from "./presentationGazVolt.vue?vue&type=template&id=35036c93"
import script from "./presentationGazVolt.vue?vue&type=script&lang=js"
export * from "./presentationGazVolt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports